const Message = (props) => {
    return(
        <div>
            <div className={"message " + props.data.messageRole}>
                <div>
                    <span>{props.data.content}</span>
                </div>
                <div>
                    <span>{props.data.timestamp}</span>
                </div>
            </div>
            <div className={"messageGap"}></div>
        </div>
    );
}

export {Message}